<span>
  <a
    [attr.data-test-id]="'table-link-' + rowIndex + '-' + cellIndex"
    class="dotted-text w-100 limit-w"
    [routerLink]="[tableRowData.link + tableRowData.entityId]"
  >
    {{ tableRowData.title }}
  </a>
</span>
